import React, { useState, useEffect, Fragment } from 'react';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Delete_Question_Option } from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from 'reactstrap';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import QuestionOptionForm from './QuestionOptionForm'
function QuestionOption({
    childQuestionshow,
    elem,
    option,
    loadResponse,
    messagesList,
    setType,
    quesionSetsList,
    formList,
    roomTags,
    productTags
}) {
    const [data, setData] = useState(option);
    const [isEditing, setIsEditing] = useState(false);

    const toggleEdit = () => {
        setIsEditing(!isEditing)
    }

    const updateOption = (name, childMessage) => {
        setData({ ...data, option: name, childQuestionId: childMessage })
        toggleEdit();
    }

    const deleteSet = () => {
        let deleteData = {
            Deleter: 'Dashboard'
        }
        try {
            AxiosAPI({
                method: 'put',
                url: `${putAPI_Delete_Question_Option}/${data.id}`,
                data: deleteData,
            })
                .then(() => {
                    loadResponse();
                });
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <Fragment>
            {data.option}
            {/* {setType === "ConversationFlow" ?
                data.childQuestionId !== null ? " (" +
                    messagesList.filter(x => x.id === data.childQuestionId).
                        map(c => c.message) + ")" : " (Add your follow-up messages)" : ""
            } */}
            <div style={{ marginLeft: '10px', display: 'inline-block' }}>
                <FontAwesomeIcon
                    icon={faEdit}
                    color="#90caf9"
                    cursor="pointer"
                    onClick={toggleEdit}
                />
                <b> | </b>
                <FontAwesomeIcon
                    icon={faTrashAlt}
                    style={{ color: 'var(--theme-color-1)' }}
                    cursor="pointer"
                    onClick={() => deleteSet()}
                />
            </div>

            <Collapse isOpen={isEditing}>
                <Colxx xxs="12" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}>
                    <QuestionOptionForm CancelQuestionOption={toggleEdit} Id={data.id}
                        optionName={data.option}
                        elem={{ ...elem }}
                        updateOption={updateOption}
                        childQuestionshow={childQuestionshow}
                        optionData={data}
                        messagesList={messagesList}
                        setType={setType}
                        quesionSetsList={quesionSetsList}
                        formList={formList}
                        roomTags={roomTags}
                        productTags={productTags}
                    ></QuestionOptionForm>
                </Colxx>
            </Collapse>
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};
export default injectIntl(connect(mapStateToProps)(QuestionOption));